<template>
  <div class="xy-content-module content">
    <div class="xy-content-body">
      <div
        v-if="!lntroduceData.IsUrl"
        style="font-size:14px;height:100vh;overflow:auto;"
        v-html="lntroduceData.Description"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      lntroduceData: {}
    }
  },
  created() {
    if (this.$route.query) {
      this.getCourseIntroduction(this.$route.query)
    }
  },
  mounted() {},
  methods: {
    async getCourseIntroduction(item) {
      console.log(item)
      this.xy.loading()
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/StudentOnLineSelectCourse/GetCourseIntroduction`,
        { classTableID: item.classTableID, aid: item.introduce.AID, type: item.introduce.Type }
      )
      this.xy.unloading()
      if (res.success) {
        this.lntroduceData = res.data
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 15px;
  background: #fff;
}
</style>
